<template>
  <div class="k-onboarding__quest-wrapper">
    <div class="k-onboarding__quest">
      <!-- <div class="k-onboarding__title">Расчёт Ккалорийности рациона и БЖУ</div> -->
      <div
        class="k-onboarding__subtitle"
      >Для вас рассчитаны рекомендуемые нормы Ккалорийности и БЖУ. Вы можете их изменить</div>
      <div class="k-onboarding__result-wrapper" v-if="localProfile">
        <div class="k-onboarding__result-row k-onboarding__row-calories">
          <div class="k-onboarding__result-row-title">Калорийность</div>
          <div class="k-onboarding__result-progress-value-wrapper">
            <div class="k-onboarding__result-row-progress">
              <div
                class="k-onboarding__result-row-progress-filled"
                :style="{width: `${caloriesPercent}%`}"
              ></div>
            </div>
            <div class="k-onboarding__result-row-value-wrapper">
              <input
                type="number"
                class="k-onboarding__result-row-value number-no-controls"
                v-model="localProfile.calories"
                @input="updateValues('calories')"
              />
              <span style="opacity: 0">%</span>
            </div>
            <span class="k-onboarding__result-row-value-percent text-left">Ккал</span>
          </div>
        </div>
        <div class="k-onboarding__result-row k-onboarding__row-proteins">
          <div class="k-onboarding__result-row-title">Белки</div>
          <div class="k-onboarding__result-progress-value-wrapper">
            <div class="k-onboarding__result-row-progress">
              <div
                class="k-onboarding__result-row-progress-filled"
                :style="{width: `${localProfile.proteins_percent}%`}"
              ></div>
            </div>
            <div class="k-onboarding__result-row-value-wrapper">
              <input
                type="number"
                class="k-onboarding__result-row-value number-no-controls"
                v-model="localProfile.proteins_percent"
                @input="updateValues('proteins_percent')"
              />
              %
            </div>
            <div class="k-onboarding__result-row-value-percent">
              <input
                type="text"
                class="number-percent"
                disabled
                v-model="localProfile.proteins_weight"
              />
              г
            </div>
          </div>
        </div>
        <div class="k-onboarding__result-row k-onboarding__row-fats">
          <div class="k-onboarding__result-row-title">Жиры</div>
          <div class="k-onboarding__result-progress-value-wrapper">
            <div class="k-onboarding__result-row-progress">
              <div
                class="k-onboarding__result-row-progress-filled"
                :style="{width: `${localProfile.fats_percent}%`}"
              ></div>
            </div>
            <div class="k-onboarding__result-row-value-wrapper">
              <input
                type="number"
                class="k-onboarding__result-row-value number-no-controls"
                v-model="localProfile.fats_percent"
                @input="updateValues('fats_percent')"
              />
              %
            </div>
            <div class="k-onboarding__result-row-value-percent">
              <input
                type="text"
                class="number-percent"
                disabled
                v-model="localProfile.fats_weight"
              />
              г
            </div>
          </div>
        </div>
        <div class="k-onboarding__result-row k-onboarding__row-carbohydrates">
          <div class="k-onboarding__result-row-title">Углеводы</div>
          <div class="k-onboarding__result-progress-value-wrapper">
            <div class="k-onboarding__result-row-progress">
              <div
                class="k-onboarding__result-row-progress-filled"
                :style="{width: `${localProfile.carbohydrates_percent}%`}"
              ></div>
            </div>
            <div class="k-onboarding__result-row-value-wrapper">
              <input
                type="number"
                class="k-onboarding__result-row-value number-no-controls"
                v-model="localProfile.carbohydrates_percent"
                @input="updateValues('carbohydrates_percent')"
              />
              %
            </div>
            <div class="k-onboarding__result-row-value-percent">
              <input
                type="number"
                class="number-percent"
                disabled
                v-model="localProfile.carbohydrates_weight"
              />
              г
            </div>
          </div>
        </div>
      </div>

      <a
        href="#"
        :class="['k-onboarding__quest-next active']"
        @click.prevent="finishOnboarding"
      >Завершить</a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { objectWithKeys } from "../utils/helper";

export default {
  name: "OnboardingResult",
  props: {
    editProfile: Object,
  },
  data() {
    return {
      maxCalories: 3000,
      localProfile: null,
      profile: null,
      timeout: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$store.state.user.currentProfile?.id || this.editProfile) {
        next();
      } else {
        next(from.name ? from : { name: "Profile" });
      }
    });
  },
  beforeMount() {
    this.localProfile = objectWithKeys(this.editProfile || this.currentProfile, [
      "id",
      "calories",
      "proteins_percent",
      "fats_percent",
      "carbohydrates_percent",
      "proteins_weight",
      "fats_weight",
      "carbohydrates_weight"
    ]);
  },
  computed: {
    ...mapGetters({
      currentProfile: "getCurrentProfile",
      family: "getUserFamily",
    }),
    caloriesPercent() {
      if (!this.localProfile) {
        return 0;
      }
      return this.localProfile.calories
        ? (this.localProfile.calories / this.maxCalories) * 100
        : 0;
    },
    getCurrentProfile() {
      return this.editProfile || this.currentProfile;
    }
  },
  watch: {
    getCurrentProfile(profile) {
      this.localProfile = Object.assign({}, profile);
    }
  },
  methods: {
    ...mapActions(["updateProfile"]),
    updateValues(lastValue) {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(async () => {
        console.log('lastValue', lastValue)
        if (lastValue === 'calories') {
          const { data } = await this.updateProfile({
            calories:  this.localProfile.calories,
            id: this.localProfile.id,
          })
          this.$emit('setNewProfile', data.profile)
          return clearTimeout(this.timeout);
        }
        if (!this.localProfile[lastValue]) {
          return clearTimeout(this.timeout);
        }
        this.localProfile.proteins_percent = parseInt(this.localProfile.proteins_percent, 10);
        this.localProfile.fats_percent = parseInt(this.localProfile.fats_percent, 10);
        this.localProfile.carbohydrates_percent = parseInt(this.localProfile.carbohydrates_percent, 10);
        this.localProfile.calories = parseInt(this.localProfile.calories, 10);

        const sum = this.localProfile.fats_percent + this.localProfile.carbohydrates_percent + this.localProfile.proteins_percent;
        const actuals_values = ['proteins_percent', 'carbohydrates_percent', 'fats_percent'].filter(el => el !== lastValue)

        if (sum !== 100) {
          const coef = (100 - this.localProfile[lastValue]) / (this.localProfile[actuals_values[0]] + this.localProfile[actuals_values[1]]);
          const new_v = (this.localProfile[actuals_values[0]] + this.localProfile[actuals_values[1]]) * coef / 2;
          console.log('actual', actuals_values[0], actuals_values[1])
          this.localProfile[actuals_values[0]] = Math.floor(new_v);
          this.localProfile[actuals_values[1]] = Math.ceil(new_v);
        }

        const {
          proteins_percent,
          fats_percent,
          carbohydrates_percent,
          calories,
          id,
          // eslint-disable-next-line no-unused-vars
          ...rest
        } = this.localProfile;

        const { data } = await this.updateProfile({
          proteins_percent,
          fats_percent,
          carbohydrates_percent,
          calories,
          id,
        })
        this.$emit('setNewProfile', data.profile)
        // this.editProfile = data.profile;
      }, 700);
    },
    finishOnboarding() {
      const {
        proteins_percent,
        fats_percent,
        carbohydrates_percent,
        calories,
        id,
        // eslint-disable-next-line no-unused-vars
        ...rest
      } = this.localProfile;

      this.updateProfile({
        id,
        proteins_percent,
        fats_percent,
        carbohydrates_percent,
        calories,
      }).then(response => {
        if (response.success) {
					if (this.profile || this.editProfile) {
						this.$router.push({ name: 'Profile', params: { id } })
					} else {
						this.$router.push("/");
					}
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.k-onboarding__title {
  font-size: 20px;
}
.k-onboarding__subtitle {
  font-size: 16px;
  width: fit-content;
}

.k-onboarding__result-wrapper {
  display: flex;
  flex-direction: column;
  width: 80%;
}

.k-onboarding__result-row {
  margin: 10px auto;
  width: 100%;
}

.k-onboarding__result-row-title {
  align-items: center;
  display: block;
  font-size: 20px;
  margin-right: 20px;
  text-align: right;
  min-width: 145px;
}

.k-onboarding__result-progress-value-wrapper {
  width: 80%;
}

.k-onboarding__result-row-progress {
  background: rgba(102, 102, 102, 0.15);
  border-radius: 12px;
  height: 24px;
  overflow: hidden;
  min-width: 70%;
}

.k-onboarding__result-row-progress-filled {
  transition: width 0.5s;
  border-radius: 12px;
}

.k-onboarding__result-row-value-wrapper {
  margin-left: 10px;
  input {
    min-width: 75px;
    width: 75px;
  }
}

.k-onboarding__result-row-value-percent {
  margin-left: 20px;
  min-width: 55px;
  max-width: 55px;
  color: darkgray;
}

.k-onboarding__result-row-value {
  border: 1px solid #cfd2d3;
  box-sizing: border-box;
  border-radius: 8px;
  color: inherit;
  flex-shrink: 0;
  height: 24px;
  margin-right: 5px;
  padding: 0 15px;
  text-align: center;
  width: 100%;
}

.k-onboarding__result-row-value:focus {
  outline: none;
}

.k-onboarding__row-calories {
  color: #f68c1e;

  .k-onboarding__result-row-progress-filled {
    background: #f68c1e;
  }

  .k-onboarding__result-row-value:focus {
    border-color: #f68c1e;
  }
}

.k-onboarding__row-proteins {
  color: #d51e3a;

  .k-onboarding__result-row-progress-filled {
    background: #d51e3a;
  }

  .k-onboarding__result-row-value:focus {
    border-color: #d51e3a;
  }
}

.k-onboarding__row-fats {
  color: #ffcc1b;

  .k-onboarding__result-row-progress-filled {
    background: #ffcc1b;
  }

  .k-onboarding__result-row-value:focus {
    border-color: #ffcc1b;
  }
}

.k-onboarding__row-carbohydrates {
  color: #9dc43b;

  .k-onboarding__result-row-progress-filled {
    background: #9dc43b;
  }

  .k-onboarding__result-row-value:focus {
    border-color: #9dc43b;
  }
}

.number-percent {
  width: 100%;
  border: 0;
  background: white;
  height: 24px;
}

@media (max-width: 1000px) {
  .k-onboarding__result-row {
    flex-direction: column;
    margin: 0;
  }

  .k-onboarding__result-row-title {
    text-align: left;
    width: 100%;
  }

  .k-onboarding__result-progress-value-wrapper {
    width: 100%;
  }

  .k-onboarding__result-row-value-wrapper {
    min-width: 75px;
    width: 75px;
  }

  .k-onboarding__result-row-progress {
  }

  .k-onboarding__result-row-value {
    margin: 0 5px 0 10px;
    padding: 0 3px;
  }

  .k-onboarding__result-row-value-percent {
    margin-left: 40px;
  }

  .k-onboarding__result-wrapper {
    width: 100%;
  }
}
@media (max-width: 580px) {
  .k-onboarding__result-progress-value-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    .k-onboarding__result-row-progress {
      width: 100%;
      margin-bottom: 10px;
    }
  }
}
</style>
`
